import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import separator from "assets/img/Separator.png";
import { CallAPI } from "services/API";
import { BannerBox } from "utils/DynamicComponents/LandingComponents";
import { Dynamic_Style } from "./Dynamic_Style";
import { BannerTitle } from "utils/DynamicComponents/LandingComponents";
import TotalBanner from "components/TotalBanner";
import TooltipButton from "utils/TooltipButton/TooltipButton";

const useMediaQuery = (query) => {
    const mediaMatch = window.matchMedia(query);
    const [matches, setMatches] = React.useState(mediaMatch.matches);

    useEffect(() => {
        const handler = e => setMatches(e.matches);
        mediaMatch.addEventListener("change", handler);
        return () => mediaMatch.removeEventListener("change", handler);
    });
    return matches;
};

export default function NewPolicies(props) {
    const isMobile = useMediaQuery('(max-width: 1152px)');

    const [data, setData] = useState({});
    const [dataYTD, setDataYTD] = useState({});

    const GetData = async () => {
        setData({});

        const response = await CallAPI("POST", "/Home/GetNewPolicies", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city
        });

        if (response)
            setData(response);
    };

    const GetDataYTD = async () => {
        setDataYTD({});

        const today = new Date();
        const response = await CallAPI("POST", "/Home/GetNewPolicies", {
            startDate: 1 + '/' + 1 + '/' + today.getFullYear(),
            endDate: (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear(),
            states: props.states,
            city: props.city
        });

        if (response)
            setDataYTD(response);
    };

    useEffect(() => {
        if (props.call == "true" || props.call == null) {
            GetData();
            GetDataYTD();
        }
    }, [props.call]);

    useEffect(() => {
        if (data.total && dataYTD.total) {
            props.onSuccess();
        }
    }, [data, dataYTD]);

    return (
        <div>
            <Grid container spacing={0} style={{marginTop: "2em",marginLeft: "1em",marginRight: "1em"}}>
                <BannerTitle
                    Header={"POLICIES"}
                />
                <Grid container
                    lg={4}
                    xs={11}
                    style={{
                        ...isMobile ? Dynamic_Style.BlueContainer_Mobile : Dynamic_Style.BlueContainer_Desktop,
                        gap: '20px',
                        flexWrap:"nowrap", overflow:"auto"
                    }}
                >
                    <BannerBox Dotted={true} ColumnSize={2} Heading={"TOTAL"} Data={data.total}/>
                    <BannerBox ColumnSize={2} Heading={"Online"} Data={data.online}/>
                    <BannerBox ColumnSize={2} Heading={"CRC"} Data={data.crc} />
                    <BannerBox ColumnSize={2} Heading={"Agency"} Data={data.agency} />
                    <BannerBox ColumnSize={2} Heading={"Combo"} Data={data.combo} Popover={"Policies quoted online initially then bound by internal CURE reps only"}/>
                </Grid>
                <Grid container
                    lg={4}
                    xs={11}
                    style={{
                        ...isMobile ? Dynamic_Style.BlueContainer_Mobile : Dynamic_Style.BlueContainer_Desktop,
                        gap: '12px', flexWrap:"nowrap", overflow:"auto"
                    }}
                >
                     <img src={separator} width="100%" style={isMobile ? Dynamic_Style.SeparatorWithOutSubHeader_Mobile : Dynamic_Style.SeparatorWithOutSubHeader_Desktop} alt="..." />
                     <span style={isMobile ? Dynamic_Style.YTDLabelWithOutSubHeader_Mobile : Dynamic_Style.YTDLabelWithOutSubHeader_Desktop}>
                         YTD
                     </span>
                    <BannerBox
                        Dotted={true}
                        ColumnSize={2}
                        Heading={"Total"}
                        Data={dataYTD.total}
                        style={{ marginLeft: '1em' }}
                    />
                    <BannerBox ColumnSize={2} Heading={"Online"} Data={dataYTD.online}/>
                    <BannerBox ColumnSize={2} Heading={"CRC"} Data={dataYTD.crc} />
                    <BannerBox ColumnSize={2} Heading={"Agency"} Data={dataYTD.agency} />
                    <BannerBox ColumnSize={2} Heading={"Combo"} Data={dataYTD.combo} Popover={"Policies quoted online initially then bound by internal CURE reps only"}/>
                </Grid>                        
            </Grid>
            {props.city === 'Detroit' && <TotalBanner
                title={<>ACTIVE <b>POLICIES</b> <TooltipButton
                    tooltipText="Active policies as of the End Date in the search."
                /></>}
                total={data.active}
            />}
        </div>
    );
}
